import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { WorkItemIntegration } from 'common/store/genesys-cloud/work-item-integrations/models/work-item-integrations.model';

@Component({
  selector: 'app-genesys-email-widget-header',
  templateUrl: './genesys-email-widget-header.component.html',
  styleUrls: ['./genesys-email-widget-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GenesysEmailWidgetHeaderComponent {
  @Input()
  externalContactFullName: string;
  @Input()
  name: string;
  @Input()
  isExpandedMode: boolean;
  @Input()
  integrations: WorkItemIntegration[];
  @Input()
  openIntegrationPanels: WorkItemIntegration[];
  @Input()
  isProactiveEmail: boolean;
  @Output()
  readonly minimize = new EventEmitter<void>();
  @Output()
  readonly toggleExpanded = new EventEmitter<void>();
  @Output()
  readonly toggleIntegration = new EventEmitter<string>();
}
